export const ADD_FAVORITE_VENUE = 'ADD_FAVORITE_VENUE'
export const ADD_FAVORITE_VENUE_SUCCESS = 'ADD_FAVORITE_VENUE_SUCCESS'
export const ADD_FAVORITE_VENUE_ERROR = 'ADD_FAVORITE_VENUE_ERROR'

export const AddFavoriteVenue = (data) => ({
  type: ADD_FAVORITE_VENUE,
  payload: data
})
